import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  sendAsset: string;
  curculateKrw: string;
  trxBalance: string;
  selectedAsset?: ViewModel.IAsset;
  fee?: number;
}

const SendTransactionAmountInfo = ({ sendAsset, curculateKrw, selectedAsset, trxBalance, fee }: IProps) => {
  // sendAsset을 안전하게 숫자로 변환
  const sendAssetNumber = Number(sendAsset.replace(/,/g, '')) || 0;
  const formattedSendAsset = isNaN(sendAssetNumber) ? 0 : Number(sendAssetNumber.toFixed(6));
  const safeFee = typeof fee === 'number' ? fee : 0;

  return (
    <div className="confirm-info-section-group">
      {/* 보낼 수량 */}
      <div className="confirm-info-section">
        <div className="confirm-info-row">
          <span className="confirm-info-label text-base font-medium">보낼 수량:</span>
          <div className="confirm-info-values">
            <span className="confirm-info-value text-base font-semibold">
              {sendAsset || '0'} {selectedAsset?.symbol || ''}
            </span>
            <span className="confirm-info-sub text-sm font-normal">{curculateKrw} 원</span>
          </div>
        </div>
      </div>

      {/* 예상수수료 */}
      <div className="confirm-info-section">
        <div className="confirm-info-row">
          <span className="confirm-info-label text-base font-medium">예상수수료:</span>
          <div className="confirm-info-values">
            <span className="confirm-info-value text-base font-semibold">{safeFee} SOL</span>
            <span className="confirm-info-sub text-sm font-normal">잔액: {trxBalance} SOL</span>
          </div>
        </div>
      </div>

      <div className="divider"></div>

      {/* 합계 */}
      <div className="confirm-info-section">
        <div className="confirm-info-row">
          <span className="confirm-info-label text-base font-medium">합계:</span>
          <div className="confirm-info-values">
            <span className="confirm-info-value text-base font-semibold">
              {formattedSendAsset} {selectedAsset?.symbol || ''}
            </span>
            <span className="confirm-info-sub text-sm font-normal">{safeFee} SOL</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendTransactionAmountInfo;
